import { CentroCustoSelectItem } from "@/Components/Populados/Financeiro/CentroConta/CentroCustoSelect";
import ContaViagem from "@/Models/Domain/Viagem/Financeiro/ContaViagem";
import { EnumCentroCustoTipo } from "@/Models/Financeiro/CentroCustoTipo";
import { EnumTipoConta } from "@/Models/Financeiro/Conta";
import { BooleanProps } from "@/utility-types";
import { Col, Divider, Form, FormInstance, FormProps, Input, Row } from "antd";
import { forwardRef } from "react";
import ViagemSelect from "../../ViagemSelect";
import ContaSelect from "@/Components/Populados/Financeiro/Conta/ContaSelect";
import { Movimentacao } from "@/Models/Financeiro/Conta/Movimentacao";
import InputPreco from "@/Components/Base/Input/InputPreco";
import InputDate from "@/Components/Base/Input/InputDate";

export interface IContaViagemFormType {
    codigo ?: number;
    contaViagem : ContaViagem;
    movimentacaoInicial ?: Movimentacao;
}
export interface IContaViagemFormBasicRef extends FormInstance<IContaViagemFormType> {

}
export interface IContaViagemFormBasicProps extends FormProps<IContaViagemFormType> {
    codigo?: number;
    fieldsDisabled?:BooleanProps<IContaViagemFormType>
}

const ContaViagemFormBasic = forwardRef<IContaViagemFormBasicRef, IContaViagemFormBasicProps>(function ContaViagemFormBasic(
    {
        codigo,
        form : formParam,
        disabled,
        component,
        layout,
        autoComplete,
        fieldsDisabled,
        ...rest
    },
    ref
) {
    const [newForm] = Form.useForm<IContaViagemFormType>();
    const form = formParam ?? newForm;

    const codigoValueForm = Form.useWatch<number|undefined>(["codigo"], form);
    const isAlteracao = codigoValueForm !== undefined && isFinite(codigoValueForm) && codigoValueForm > 0;

    const contaFilhaMovimentacaoFormValue = Form.useWatch(["movimentacaoInicial", "movimentacaoFilha", "codConta"], form);
    const dataMovimentacaoFormValue = Form.useWatch(["movimentacaoInicial", "dataMovimentacao"], form);
    const valorTransacaoFormValue = Form.useWatch(["movimentacaoInicial", "valorTransacao"], form);

    const fazerMovimentacaoInicial = contaFilhaMovimentacaoFormValue !== undefined || (dataMovimentacaoFormValue !== null && dataMovimentacaoFormValue !== undefined) || valorTransacaoFormValue > 0;

    return <Form
        {...rest}
        ref={ref}
        form={form}
        disabled={disabled}
        component={component ?? "div"}
        layout={layout ?? "vertical"}
        autoComplete={autoComplete ?? "off"}
    >
        <Row gutter={8} wrap>
            <Form.Item<IContaViagemFormType> name={"codigo"} hidden><Input hidden /></Form.Item>
            
            <Form.Item<IContaViagemFormType> name={["contaViagem", "conta", "codTipoConta"]} hidden initialValue={EnumTipoConta.CAIXA}>
                <Input hidden />
            </Form.Item>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<IContaViagemFormType> name={["contaViagem", "conta", "nome"]} label="Nome" rules={[ { required : true } ]}>
                    <Input />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<IContaViagemFormType> name={["contaViagem", "codCentroCusto"]} label="Centro de custos" rules={[ { required : true } ]}>
                    <CentroCustoSelectItem 
                        disabled={isAlteracao}
                        filtros={{
                            tipo : {
                                codigo : EnumCentroCustoTipo.ITEM
                            },
                            ativo : true
                        }}  
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<IContaViagemFormType> name={["contaViagem", "codViagem"]} label="Viagem" rules={[ { required : false } ]}>
                    <ViagemSelect disabled={isAlteracao} />
                </Form.Item>
            </Col>
            {
                isAlteracao === false && <>
                    <Divider orientation="left">Saldo inicial:</Divider>
                    <Col xs={24} sm={12} md={10} lg={8} xl={6} xxl={6}>
                        <Form.Item<IContaViagemFormType> name={["movimentacaoInicial", "movimentacaoFilha", "codConta"]} label="Conta origem" rules={[ { required : fazerMovimentacaoInicial } ]}>
                            <ContaSelect 
                                filtros={{
                                    codTiposInvalidos : [EnumTipoConta.ADIANTAMENTO_VIAGEM]
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={4} lg={8} xl={4} xxl={3}>
                        <Form.Item<IContaViagemFormType> name={["movimentacaoInicial", "dataMovimentacao"]} label="Data" rules={[{ required: fazerMovimentacaoInicial }]}>
                            <InputDate showTime={false} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6} lg={8} xl={4} xxl={3}>
                        <Form.Item<IContaViagemFormType> name={["movimentacaoInicial", "valorTransacao"]} label="Valor" rules={[{ required: fazerMovimentacaoInicial }]}>
                            <InputPreco placeholder="Informe" />
                        </Form.Item>
                    </Col>
                </>
            }
        </Row>
    </Form>
});

export default ContaViagemFormBasic;